export const REQUIREMENT_DATA = {
  qualifying: {
    name: 'Qualifying',
    requirements: {
      'background_check': {
        name: 'Background Check',
        statuses: {
          'ready': {
            label: 'Ready',
            message: 'To apply as an Associate, please complete a background check through HireRight.',
            primaryLinkText: 'Start Background Check',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'pending': {
            label: 'Pending',
            message: 'Your background check was submitted [X days ago]. Results can take, on average, 2-4 business days.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Your background check was approved!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'denied': {
            label: 'Denied',
            message: "Unfortunately, your background check did not pass. Please reach out to our team to discuss your options.",
            primaryLinkText: 'Contact Member Services',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'expired': {
            label: 'Expired',
            message: 'To apply as an Associate, please complete a new background check.',
            primaryLinkText: 'Start Background Check',
            primaryLinkUrl: 'https://account.pga.org/background-check',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'playing_ability_test': {
        name: 'Playing Ability Test (PAT)',
        statuses: {
          'ready': {
            label: 'Ready',
            message: 'Your next major step: register for the Playing Ability Test (PAT).',
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: 'Learn More',
            infoLinkUrl: '/membership/associate-program/path-to-membership-articles/playing-ability-test-pat'
          },
          'deferred': {
            label: 'Deferred',
            message: "You've chosen to defer your PAT for now. Register when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: "Your PAT is on Thursday, Sept 25th at 2:00pm EDT.",
            primaryLinkText: 'See Event Details',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'qualified': {
            label: 'Qualified',
            message: "Congratulations, you have qualifying scores! Register again when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: 'Learn More',
            infoLinkUrl: '/membership/associate-program/path-to-membership-articles/playing-ability-test-pat'
          },
          'failed': {
            label: 'Failed',
            message: "Unfortunately, your scores aren't passing. Register to try again when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Passed',
            message: 'Major milestone complete: you passed!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'expired': {
            label: 'Expired',
            message: "Unfortunately, your scores expired. Register to try again when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Coursework',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'application': {
        name: 'Application',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to purchase Level 1.",
            primaryLinkText: 'Purchase Level 1',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'submitted': {
            label: 'Submitted',
            message: 'Your application has been submitted and is currently being reviewed.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Congratulations, you have completed the Qualifying Level!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level1: {
    name: 'Level 1',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the Facility Management 1 course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'incomplete': {
            label: 'Incomplete',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'virtual_seminar': {
        name: 'Virtual Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Find a week-long, virtual seminar to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: 'https://events.pga.org/search?query=virtual%20seminar%20level%201',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-virtual-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Your virtual seminar is booked... time to start preparing.',
            primaryLinkText: 'View Guide',
            primaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-virtual-seminar',
            secondaryLinkText: 'My Event Calendar',
            secondaryLinkUrl: 'https://events.pga.org/my-events',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'attending': {
            label: 'Attending',
            message: "It's seminar week! Class runs from 8:00AM-4:00PM CT daily. Your virtual conference opens at 7:45AM CT.",
            primaryLinkText: 'Join Seminar',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/462/conferences',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-virtual-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Thank you for participating in the virtual seminar.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: 'https://pgaofamerica.instructure.com/courses/463/modules',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l1-portfolio',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 1 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'purchase': {
        name: 'Purchase Level 2',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to purchase Level 2.",
            primaryLinkText: 'Purchase Level 2',
            primaryLinkUrl: '',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-registration',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you have completed Level 1!",
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level2: {
    name: 'Level 2',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the [course name] course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'incomplete': {
            label: 'Incomplete',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'seminar': {
        name: 'Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Find a week-long seminar in Frisco, TX to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: 'https://events.pga.org/search?query=3.0%2F3.1%20seminar',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Your seminar in Frisco, TX is booked... time to start preparing.',
            primaryLinkText: 'View Guide',
            primaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-seminar',
            secondaryLinkText: 'My Event Calendar',
            secondaryLinkUrl: 'https://events.pga.org/my-events',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: "It's seminar week! Class is at the Home of the PGA of America from 8:00-4:00PM CT daily.",
            primaryLinkText: 'Directions to PGA HQ',
            primaryLinkUrl: 'https://maps.app.goo.gl/Y24jpQ23PHLdqp5z9',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Your seminar week is complete. Thank you for visiting the Home of the PGA of America in Frisco, TX.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l2-portfolio',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 2 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'purchase': {
        name: 'Purchase Level 3',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to purchase Level 3.",
            primaryLinkText: 'Purchase Level 3',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-registration',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you have completed Level 2!",
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level3: {
    name: 'Level 3',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Open the Education Portal to view the course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'incomplete': {
            label: 'Incomplete',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-course-manuals',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'seminar': {
        name: 'Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Find a week-long seminar in Frisco, TX to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: 'https://events.pga.org/search?query=3.0%2F3.1%20seminar',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Your seminar in Frisco, TX is booked... time to start preparing.',
            primaryLinkText: 'View Guide',
            primaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-seminar',
            secondaryLinkText: 'My Event Calendar',
            secondaryLinkUrl: 'https://events.pga.org/my-events',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'attending': {
            label: 'Attending',
            message: "It's seminar week! Class is at the Home of the PGA of America from 8:00-4:00PM CT daily.",
            primaryLinkText: 'Directions to PGA HQ',
            primaryLinkUrl: 'https://www.google.com/maps/place/1916+PGA+Pkwy,+Frisco,+TX+75034',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-seminar',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Your seminar week is complete. Thank you for visiting the Home of the PGA of America in Frisco, TX.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: '#',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: '/membership/associate-program/path-to-membership-articles/l3-portfolio',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 3 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'final_exam': {
        name: 'Final Exam',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 3 Requirements to become eligible for the Final Exam.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: 'You are now elible to take your Final Exam!',
            primaryLinkText: 'Take the Exam',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Congratulations, you have completed the final step in your Path to Membership!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'enrollment': {
        name: 'PGA Membership Application',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to submit your application for Membership.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'ready': {
            label: 'Ready',
            message: "Congratulations, you're now eligible to apply for PGA of America Membership.",
            primaryLinkText: 'Apply for Membership',
            primaryLinkUrl: 'https://account.pga.org/applications/membership',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'submitted': {
            label: 'Submitted',
            message: 'Your application has been submitted and is currently being reviewed.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you are officially a PGA of America Member! Welcome!",
            primaryLinkText: "What's Next",
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  }
}
